module.exports = __webpack_public_path__ + "img/icon_map_1_yj_hg.a26dd163.png";